import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar";
import { TooltipAgendamento } from "./TooltipAgendamento";
import { TooltipPeriodoTeste } from "./TooltipPeriodoTeste";
import Button from "../../common/button/button";
import AlertIcon from "../../common/alertIcon/alertIcon";
import { TabelaDemandaContratada } from "./TabelaDemandaContratada";
import DateFormat from "../../common/dateFormat/DateFormat";
import { calcularFatorPotencia } from "../../core/calcularFatorPotencia";
import { IndicadorLeiturasFaltando } from "./IndicadorLeiturasFaltando";
import ContentCard from "../../common/template/contentCard";
import ContentCardBody from "../../common/template/contentCardBody";
import { RowFlex } from "../../common/layout/RowFlex";
import Grid from "../../common/layout/grid";
import { getListaGraficoDia, getMonitoramentoConsumo, setModoTela, setStatusVisualizado } from "../monitoramentoConsumoActions";
import { setPeriodoTesteVisualizado } from "../../demandaContrato/demandaContratoActions";
import { buscarPdfUnifilarRedeInterna } from "../../rede/redeActions";
import { setArquivoPDF } from "../../displayPDF/displayPDFActions";
import { IndicadorDemandasAtingidasUltrapassagemMobile } from "./IndicadorDemandasAtingidasUltrapassagemMobile";

function MonitoramentoConsumoCardMobileComponent(props) {
    // Estado local para manter kvar_ind_simulado
    const [kvarIndSimulado, setKvarIndSimulado] = useState(props.item.consumoLeitura.kvar_ind_simulado || 0);
    // sem id significa que não tem contrato de demanda, então exibe uma mensagem e oculta os dados de demanda
    const sazonalidadeDiferenteDaUC = props.item.id && props.item.contrato_demanda_sazonal != props.item.sazonal;

    const horosazonalVerde = props.item.id_modalidade_tarifaria == 1;
    const horosazonalAzul = props.item.id_modalidade_tarifaria == 2;
    const corTabelaDemanda = horosazonalVerde ? "#00d85f" : horosazonalAzul ? "#34cbff" : "#ddd";

    // Compara a magnitude do reativo indutivo e capacitivo, aceitando kvar_cap positivo ou negativo
    const q =
        Math.abs(parseFloat(props.item.consumoLeitura.kvar_ind) || 0) >=
        Math.abs(parseFloat(props.item.consumoLeitura.kvar_cap) || 0)
            ? Math.abs(parseFloat(props.item.consumoLeitura.kvar_ind) || 0)
            : Math.abs(parseFloat(props.item.consumoLeitura.kvar_cap) || 0) * -1;

    const fatorPotencia = calcularFatorPotencia({
        p: props.item.consumoLeitura.kw,
        q,
    });

    //define se está online ou offline ---------------------------------------------
    const dataHoraLeitura = new Date(props.item.consumoLeitura.data_hora);
    const dataHoraAtualValidacaoRecente = new Date();
    dataHoraAtualValidacaoRecente.setMinutes(dataHoraAtualValidacaoRecente.getMinutes() - 60);
    const onlineRecentemente = dataHoraLeitura >= dataHoraAtualValidacaoRecente;

    const dataAtual = new Date();
    const leituraMesAtual = dataHoraLeitura.getFullYear() === dataAtual.getFullYear() && dataHoraLeitura.getMonth() === dataAtual.getMonth();

    let exibirAlertaPkwVermelho = false;
    let exibirAlertaPkwVerde = false;

    if (leituraMesAtual) {
        //1 fora ponta e 2 ponta
        if (props.filtro.id_tipo_contrato_demanda == 1) {
            exibirAlertaPkwVermelho = parseFloat(props.item.consumoLeitura.kw) > parseFloat(props.item.demanda_fora_ponta_contratada_mes_atual) * 1.05;
            exibirAlertaPkwVerde =
                parseFloat(props.item.consumoLeitura.kw) >= parseFloat(props.item.demanda_fora_ponta_contratada_mes_atual) &&
                parseFloat(props.item.consumoLeitura.kw) <= parseFloat(props.item.demanda_fora_ponta_contratada_mes_atual) * 1.05;
        } else if (props.filtro.id_tipo_contrato_demanda == 2) {
            exibirAlertaPkwVermelho = parseFloat(props.item.consumoLeitura.kw) > parseFloat(props.item.demanda_ponta_contratada_mes_atual) * 1.05;
            exibirAlertaPkwVerde =
                parseFloat(props.item.consumoLeitura.kw) >= parseFloat(props.item.demanda_ponta_contratada_mes_atual) &&
                parseFloat(props.item.consumoLeitura.kw) <= parseFloat(props.item.demanda_ponta_contratada_mes_atual) * 1.05;
        }
    }

    const valorQAlterado = parseFloat(q) && kvarIndSimulado && kvarIndSimulado !== parseFloat(q);

    const grupoFaturamentoTipoMedicao =
        props.item.id_grupo_faturamento == 1 && props.item.id_tipo_medicao == 1
            ? "GA - Med. BT"
            : props.item.id_grupo_faturamento == 1 && props.item.id_tipo_medicao == 2
              ? "GA - Med. MT"
              : props.item.id_grupo_faturamento == 2 && props.item.id_tipo_medicao == 1
                ? "GB - Med. BT"
                : props.item.id_grupo_faturamento == 2 && props.item.id_tipo_medicao == 2
                  ? "GB - Med. MT"
                  : props.item.id_grupo_faturamento == 3 && props.item.id_tipo_medicao == 1
                    ? "GA/FB - Med. BT"
                    : props.item.id_grupo_faturamento == 3 && props.item.id_tipo_medicao == 2
                      ? "GA/FB - Med. MT"
                      : props.item.id_grupo_faturamento == 4 && props.item.id_tipo_medicao == 1
                        ? "GA/FA - Med. BT"
                        : props.item.id_grupo_faturamento == 4 && props.item.id_tipo_medicao == 2
                          ? "GA/FA - Med. MT"
                          : "INDEFINIDO";

    const titleGrupoFaturamentoTipoMedicao =
        props.item.id_grupo_faturamento == 1 && props.item.id_tipo_medicao == 1
            ? "Grupo A com medição de Baixa Tensão"
            : props.item.id_grupo_faturamento == 1 && props.item.id_tipo_medicao == 2
              ? "Grupo A com medição de Média Tensão"
              : props.item.id_grupo_faturamento == 2 && props.item.id_tipo_medicao == 1
                ? "Grupo B com medição de Baixa Tensão"
                : props.item.id_grupo_faturamento == 2 && props.item.id_tipo_medicao == 2
                  ? "Grupo B com medição de Média Tensão"
                  : props.item.id_grupo_faturamento == 3 && props.item.id_tipo_medicao == 1
                    ? "Grupo A/Faturado em B com medição de Baixa Tensão"
                    : props.item.id_grupo_faturamento == 3 && props.item.id_tipo_medicao == 2
                      ? "Grupo A/Faturado em B com medição de Média Tensão"
                      : props.item.id_grupo_faturamento == 4 && props.item.id_tipo_medicao == 1
                        ? "Grupo A/Faturado em A com medição de Baixa Tensão"
                        : props.item.id_grupo_faturamento == 4 && props.item.id_tipo_medicao == 2
                          ? "Grupo A/Faturado em A com medição de Média Tensão"
                          : "INDEFINIDO";

    const corVermelha = "#ff3164";
    const corVerde = "#15b85b";
    const estiloCelulaTensaoCorrente = { border: "1px solid #ccc", padding: "2px 5px", textAlign: "center", minWidth: 35, textWrap: "nowrap", fontSize: "0.8rem" };

    // return props.modoCard ? (
    return (
        <ContentCard style={{ backgroundColor: props.backgroundColor, color: props.color, borderRadius: 12, marginBottom: 35, lineHeight: 0.88 }}>
            <ContentCardBody padding="10px">
                <RowFlex style={{ justifyContent: "center", padding: "0 !important" }}>
                    <h6 style={{ textAlign: "center", fontSize: props.item.nome_unidade_consumidora && props.item.nome_unidade_consumidora.length > 45 ? "0.95rem" : "1rem" }}>{props.item.nome_unidade_consumidora}</h6>
                </RowFlex>
                <RowFlex style={{ justifyContent: "center", padding: "0 !important" }}>
                    <div className="d-flex align-items-center" style={{ position: "relative", marginTop: 10 }}>
                        <div
                            style={{
                                position: "absolute",
                                left: 5,
                                top: -2,
                                fontSize: "1rem",
                                color: onlineRecentemente ? corVerde : corVermelha,
                            }}
                        >
                            <i className="fas fa-wifi"></i>
                        </div>
                        {!onlineRecentemente && (
                            <div
                                style={{
                                    position: "absolute",
                                    left: 5,
                                    top: -2,
                                    fontSize: "1rem",
                                    color: corVermelha,
                                }}
                            >
                                <i className="fas fa-slash"></i>
                            </div>
                        )}
                        <span
                            style={{
                                fontSize: "0.7rem",
                                paddingTop: 18,
                                color: onlineRecentemente ? corVerde : corVermelha,
                            }}
                        >
                            {onlineRecentemente ? <b>online</b> : <b>offline</b>}
                        </span>
                        {props.item.consumoLeitura.data_hora ? (
                            <div style={{ paddingLeft: 12, fontSize: "0.8rem" }}>{DateFormat.formatarDataHoraSqlParaTelaShortYear(props.item.consumoLeitura.data_hora)}</div>
                        ) : (
                            "-"
                        )}
                    </div>
                </RowFlex>
                <RowFlex style={{ justifyContent: "center", padding: "0 !important" }}>
                    {sazonalidadeDiferenteDaUC ? (
                        <div
                            style={{
                                backgroundColor: "#fd5959",
                                color: "#ffffff",
                                padding: 5,
                                borderRadius: "0.3rem",
                                textAlign: "center",
                            }}
                        >
                            <div style={{ width: "100%", minWidth: 150 }}>
                                <div>A sazonalidade da UC é diferente do contrato</div>
                                <div>
                                    (UC:{props.item.contrato_demanda_sazonal ? " Sazonal " : " Não Sazonal "} - Contrato:
                                    {props.item.sazonal ? " Sazonal " : " Não Sazonal "})
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="d-flex">
                            <TooltipAgendamento item={props.item} mobile={true} />
                            <TooltipPeriodoTeste
                                setPeriodoTesteVisualizado={props.setPeriodoTesteVisualizado}
                                getMonitoramentoConsumo={props.getMonitoramentoConsumo}
                                item={props.item}
                            />
                        </div>
                    )}
                </RowFlex>
                <RowFlex style={{ justifyContent: "flex-end", padding: "0 !important" }}>
                    <Button
                        style={{ width: "100%", height: 70, margin: 8 }}
                        title="Ver o gráfico do dia"
                        text={
                            <div>
                                <div>
                                    <i style={{ fontSize: "2rem" }} className="fas fa-chart-line"></i>
                                </div>
                                <b>P e Q</b>
                            </div>
                        }
                        type={"info"}
                        event={() => {
                            props.getListaGraficoDia({
                                id_consumo_integracao: props.item.consumoLeitura.id_consumo_integracao,
                                dataInicial: props.dataInicialGrafico,
                                dataFinal: props.dataFinalGrafico,
                            });
                            props.setModoTela("graficoDia", props.item);
                        }}
                    />
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                        <IndicadorLeiturasFaltando item={props.item} visible={props.usuarioLogado.administrador} mobile={true}/>
                    </div>
                </RowFlex>

                <RowFlex style={{ padding: "5px", margin: 1, border: "2px solid rgb(161 90 9)", borderRadius: "5px" }}>
                    <Grid cols="12 12 12 12"
                        style={{ marginBlock: 0, border: "2px solid #FFF", borderRadius: 10, background: `linear-gradient(145deg, ${props.backgroundColor} 10%, #0f6a7c 55%, #082f3d 100%)`, boxShadow: "0 6px 18px rgba(0,0,0,0.18)", overflow: "hidden" }}>
                        <div style={{ textAlign: "center", lineHeight: "1.1rem" }}>
                            {exibirAlertaPkwVermelho && (
                                <AlertIcon
                                    animationClass={props.item.consumoLeitura.status_visualizado_kw ? "alerta-triangulo-visualizado" : "alerta-triangulo"}
                                    title="A demanda medida em kW está igual ou superior à contratada"
                                    event={() => {
                                        if (window.confirm('A demanda medida em kW está igual ou superior à contratada, deseja marcar alerta como "visualizado"?')) {
                                            props.setStatusVisualizado({
                                                id: props.item.consumoLeitura.id,
                                                coluna: "status_visualizado_kw",
                                            });
                                            props.item.consumoLeitura.status_visualizado_kw = true;
                                        }
                                    }}
                                />
                            )}
                            {!isNaN(parseFloat(props.item.consumoLeitura.kw)) ? (
                                <>
                                    <div style={{ fontSize: "0.78rem", fontWeight: "bold", textAlign: "center", marginTop: 10, letterSpacing: "0.6px", textTransform: "uppercase", opacity: 0.9 }}>
                                        Potências Instantânea
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 8, marginBottom: 15, gap: 14 }}>
                                        {/* Potência em kW */}
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", whiteSpace: "nowrap", flexShrink: 0 }}>
                                            <span style={{ fontSize: "1.6rem", fontWeight: "bold", lineHeight: 1 }}>
                                                P ={" "}
                                                <span style={{ color: exibirAlertaPkwVermelho ? corVermelha : exibirAlertaPkwVerde ? corVerde : null }}>
                                                    {(Math.trunc(
                                                        Number(parseFloat(props.item.consumoLeitura.kw).toFixed(2)) * 10
                                                    ) / 10).toLocaleString("pt-BR", {
                                                        minimumFractionDigits: 1,
                                                        maximumFractionDigits: 1,
                                                    })}
                                                </span>
                                            </span>

                                            <span style={{ fontSize: "1.6rem", fontWeight: "bold", marginLeft: 6 }}>
                                                kW
                                            </span>
                                        </div>
                                        {/* Conversão aproximada para CV */}
                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flexShrink: 0,}}>
                                            <span style={{ fontSize: "1rem", fontWeight: "bold", lineHeight: 1, whiteSpace: "nowrap" }}>
                                                ({Math.round(parseFloat(props.item.consumoLeitura.kw) / 0.8)} CV)
                                            </span>
                                            <span style={{ fontSize: "0.55rem", fontWeight: "bold", lineHeight: 1.1, marginTop: 3 }}>
                                                Representação
                                                <br />
                                                aproximada em CV
                                            </span>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                "-"
                            )}
                        </div>
                    </Grid>
                    <Grid cols="12 12 12 12" style={{ marginBlock: 0, marginTop: 6, border: "2px solid #FFF", borderRadius: "10px", paddingBlock: 5, overflow: "hidden", background: `linear-gradient(145deg, ${props.backgroundColor} 10%, #0f6a7c 55%, #082f3d 100%)` }}>
                        <RowFlex style={{ padding: "0 !important", alignItems: "flex-start" }}>
                        {/* Q / S / FP */}
                        <Grid cols="5 5 5 5" style={{ marginTop: 20 }}>
                            <div title={
                                    props.item.consumoLeitura.potencia_reativa_a ||
                                    props.item.consumoLeitura.potencia_reativa_b ||
                                    props.item.consumoLeitura.potencia_reativa_c
                                        ? `(Potência Reativa A: ${adicionarPontosMilhar(
                                            props.item.consumoLeitura.potencia_reativa_a
                                        )}, Potência Reativa B: ${adicionarPontosMilhar(
                                            props.item.consumoLeitura.potencia_reativa_b
                                        )}, Potência Reativa C: ${adicionarPontosMilhar(
                                            props.item.consumoLeitura.potencia_reativa_c
                                        )}) multiplicadas pela constante do medidor`
                                        : "Q(kVAr) multiplicado pela constante do medidor"
                                }
                                style={{ textAlign: "center", position: "relative", textDecoration: valorQAlterado ? "line-through" : "none" }}
                            >
                                {!isNaN(parseFloat(q)) ? (
                                    <h6 style={{ whiteSpace: "nowrap", fontSize: "0.93rem" }}>
                                        Q =
                                        <span style={{ marginInline: 4 }}>
                                            {(Math.trunc(
                                                Number(parseFloat(q).toFixed(2)) * 10
                                            ) / 10).toLocaleString("pt-BR", {
                                                minimumFractionDigits: 1,
                                                maximumFractionDigits: 1,
                                            })}
                                        </span>
                                        kVAr
                                    </h6>
                                ) : (
                                    "-"
                                )}
                            </div>
                                {valorQAlterado ? (
                                    <div style={{ textAlign: "center" }}>
                                        {adicionarPontosMilhar(kvarIndSimulado)}
                                    </div>
                                ) : null}

                            <div style={{ textAlign: "center" }}>
                                {!isNaN(parseFloat(props.item.consumoLeitura.kw)) && !isNaN(parseFloat(q)) ? (
                                    <h6 style={{ whiteSpace: "nowrap", fontSize: "0.93rem" }}>
                                        S =
                                        <span style={{ marginInline: 4, fontSize: "0.93rem" }}>
                                            {(Math.trunc(
                                                Number(
                                                    Math.sqrt(
                                                        Math.pow(parseFloat(props.item.consumoLeitura.kw), 2) +
                                                        Math.pow(parseFloat(q), 2)
                                                    ).toFixed(2)
                                                ) * 10
                                            ) / 10).toLocaleString("pt-BR", {
                                                minimumFractionDigits: 1,
                                                maximumFractionDigits: 1,
                                            })}
                                        </span>
                                        kVA
                                    </h6>
                                ) : (
                                    "-"
                                )}
                                    {!isNaN(fatorPotencia) ? (
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", lineHeight: "1.1rem", fontSize: "0.93rem", color: fatorPotencia < 0.92 ? corVermelha : corVerde }}>
                                            {fatorPotencia < 0.92 && (
                                                <AlertIcon
                                                    animationClass={ props.item.consumoLeitura.status_visualizado_fp ? "alerta-triangulo-visualizado" : "alerta-triangulo"}
                                                    title="FP está abaixo de 0,92"
                                                    event={() => {
                                                        if (window.confirm('FP está abaixo de 0,92, deseja marcar alerta como "visualizado"?')) {
                                                            props.setStatusVisualizado({ id: props.item.consumoLeitura.id, coluna: "status_visualizado_fp" });
                                                            props.item.consumoLeitura.status_visualizado_fp = true;
                                                        }
                                                    }}
                                                />
                                            )}
                                            <div>
                                                <h6 title="FP = P / S">
                                                    FP =
                                                    <span style={{ marginInline: 4 }}>
                                                        {adicionarPontosMilhar(fatorPotencia)}
                                                    </span>
                                                </h6>
                                            </div>
                                        </div>
                                    ) : (
                                        "-"
                                    )}
                            </div>
                        </Grid>

                        <Grid cols="3 3 3 3">
                            <div style={{ textAlign: "center", fontWeight: "bold", marginBottom: "3px"}}>
                                Tensão
                            </div>

                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <tbody>
                                    <tr>
                                        <td style={estiloCelulaTensaoCorrente}>A</td>
                                        <td style={estiloCelulaTensaoCorrente}>
                                            {adicionarPontosMilhar(props.item.consumoLeitura.tensao_secundaria_a) || "-"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={estiloCelulaTensaoCorrente}>B</td>
                                        <td style={estiloCelulaTensaoCorrente}>
                                            {adicionarPontosMilhar(props.item.consumoLeitura.tensao_secundaria_b) || "-"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={estiloCelulaTensaoCorrente}>C</td>
                                        <td style={estiloCelulaTensaoCorrente}>
                                            {adicionarPontosMilhar(props.item.consumoLeitura.tensao_secundaria_c) || "-"}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Grid>

                        <Grid cols="4 4 4 4">
                            <div style={{ textAlign: "center", fontWeight: "bold", marginBottom: "3px"}}>
                                Corrente
                            </div>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <tbody>
                                    <tr>
                                        <td style={estiloCelulaTensaoCorrente}>A</td>
                                        <td style={estiloCelulaTensaoCorrente}>
                                            {adicionarPontosMilhar(props.item.consumoLeitura.corrente_secundaria_a) || "-"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={estiloCelulaTensaoCorrente}>B</td>
                                        <td style={estiloCelulaTensaoCorrente}>
                                            {adicionarPontosMilhar(props.item.consumoLeitura.corrente_secundaria_b) || "-"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={estiloCelulaTensaoCorrente}>C</td>
                                        <td style={estiloCelulaTensaoCorrente}>
                                            {adicionarPontosMilhar(props.item.consumoLeitura.corrente_secundaria_c) || "-"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={estiloCelulaTensaoCorrente}>N</td>
                                        <td style={estiloCelulaTensaoCorrente}>
                                            {adicionarPontosMilhar(props.item.consumoLeitura.corrente_secundaria_n) || "-"}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Grid>
                    </RowFlex>
                    </Grid>
                </RowFlex>

                <RowFlex style={{ justifyContent: "center", padding: "0 !important", margin: "10px 1px 20px 1px" }}>
                    <Grid cols="12 12 12 12" style={{ marginBlock: 0, padding: 0 }}>
                        <RowFlex style={{ padding: "0 !important", margin: 0, alignItems: "stretch" }}>
                            <Grid cols="5 5 5 5" style={{ padding: 0, paddingRight: 3, display: "flex" }}>
                                <div style={{ width: "100%", borderRadius: 5, overflow: "hidden", backgroundColor: "#023b49", border: "2px solid rgb(255, 255, 255)", boxShadow: "0 0 8px rgba(255,255,255,0.10)", textAlign: "center", color: "#FFF" }}>
                                    <div style={{ display: "flex", justifyContent: "center", padding: "7px 2px 4px 2px", fontSize: "0.48rem", fontWeight: "bold", borderBottom: "1px solid rgba(255,255,255,0.25)", whiteSpace: "nowrap", width: "100%", overflow: "visible"}}>
                                        Maior Demanda do Mês Atual
                                    </div>
                                    <div style={{ padding: "4px 4px", fontSize: "1.25rem", fontWeight: "bold", lineHeight: 1.2, backgroundColor: props.item.consumoLeitura.cor_maior_demanda_mes, borderBottom: "1px solid rgba(255,255,255,0.20)" }}>
                                        {!isNaN(parseFloat(props.item.consumoLeitura.maior_demanda_mes))
                                            ? `${(Math.trunc(
                                                Number(parseFloat(props.item.consumoLeitura.maior_demanda_mes).toFixed(2)) * 10
                                            ) / 10).toLocaleString("pt-BR", {
                                                minimumFractionDigits: 1,
                                                maximumFractionDigits: 1,
                                            })} kW`
                                            : "-"}
                                    </div>
                                    <div style={{ padding: "5px 4px 7px 4px", fontSize: "0.72rem", lineHeight: 1.2 }}>
                                        <div>Atingida em</div>
                                        <div style={{ fontWeight: "bold" }}>
                                            {props.item.consumoLeitura.datahora_maior_demanda_mes ? DateFormat.formatarDataHoraSqlParaTela(props.item.consumoLeitura.datahora_maior_demanda_mes) : "-"}
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                            <Grid cols="7 7 7 7" style={{ padding: 0, paddingLeft: 3, display: "flex" }}>
                                <div style={{ width: "100%", borderRadius: 5, overflow: "hidden", border: `2px solid ${corTabelaDemanda}`, color: "#FFF" }}>
                                    <div style={{ textAlign: "center", padding: "7px 4px", fontSize: "0.72rem", fontWeight: "bold", borderBottom: `1px solid ${corTabelaDemanda}` }}>
                                        Demanda Contratada Mês Atual
                                    </div>
                                    <div style={{ padding: "2px 3px 3px 3px" }}>
                                        <TabelaDemandaContratada
                                            corTabelaDemanda={corTabelaDemanda}
                                            item={props.item}
                                            tableWidth="100%"
                                            mobile={true}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </RowFlex>
                    </Grid>
                </RowFlex>
                <RowFlex style={{ justifyContent: "flex-end", padding: "0 !important" }}>
                    <Grid cols="12 12 12 12">
                        <div style={{ width: "100%" }}>
                            <IndicadorDemandasAtingidasUltrapassagemMobile
                                titleGrupoFaturamentoTipoMedicao={titleGrupoFaturamentoTipoMedicao}
                                grupoFaturamentoTipoMedicao={grupoFaturamentoTipoMedicao}
                                ultimaLinha={props.ultimaLinha}
                                item={props.item}
                                color={props.color}
                                sazonalidadeDiferenteDaUC={sazonalidadeDiferenteDaUC}
                            />
                        </div>
                    </Grid>
                </RowFlex>
                <RowFlex style={{ justifyContent: "flex-end", padding: "0 !important" }}>
                    <Grid cols="12 12 12 12">
                        <Button
                            style={{ margin: 0 }}
                            text="Análise de Demanda Contratada"
                            type={"purple"}
                            icon={"fas fa-chart-bar"}
                            visible={true}
                            solid={true}
                            disabled={!props.item.id}
                            event={() => {
                                const ucCompleta = props.listaUnidadeConsumidora.find((uc) => uc.id === props.item.id_unidade_consumidora) || {};
                                props.setExibirModalAnaliseDemandaContratada(true);
                                props.setItemSelecionado({ ...props.item, id_cliente: ucCompleta.id_cliente });
                            }}
                        />
                    </Grid>
                    <Grid cols="12 12 12 12">
                        <Button
                            title={"Unifilar de Rede Interna"}
                            style={{ margin: 0 }}
                            text={"Rede Elétrica Interna"}
                            type={"light"}
                            icon={"fas fa-network-wired"}
                            visible={true}
                            solid={true}
                            disabled={!props.item.possui_unifilar_rede_interna}
                            event={() => {
                                props.buscarPdfUnifilarRedeInterna({
                                    id_unidade_consumidora: props.item.id_unidade_consumidora,
                                    nome: `Mapa_unifilar_rede_interna`,
                                });
                                props.setArquivoPDF();
                            }}
                        />
                    </Grid>
                </RowFlex>
            </ContentCardBody>
        </ContentCard>
    );
}

const mapStateToProps = (state) => {
    return {
        usuarioLogado: state.auth.usuarioLogado,
        filtro: state.monitoramentoConsumo.filtro,
        listaUnidadeConsumidora: state.monitoramentoConsumo.listaUnidadeConsumidora,
        listaMonitoramentoConsumo: state.monitoramentoConsumo.listaMonitoramentoConsumo,
        dataInicialGrafico: state.monitoramentoConsumo.dataInicialGrafico,
        dataFinalGrafico: state.monitoramentoConsumo.dataFinalGrafico,
    };
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            buscarPdfUnifilarRedeInterna,
            setArquivoPDF,
            setModoTela,
            getListaGraficoDia,
            getMonitoramentoConsumo,
            setStatusVisualizado,
            setPeriodoTesteVisualizado,
        },
        dispatch
    );
const MonitoramentoConsumoCardMobile = connect(mapStateToProps, mapDispatchToProps)(MonitoramentoConsumoCardMobileComponent);
export { MonitoramentoConsumoCardMobile };
